<template>
	<transition-group
		:class="$style['notification']"
		tag="div"
		name="rc-notification"
	>
		<div
			v-for="notification in notifications"
			:key="notification.id"
			:class="[$style['notification__item'], {
				[$style['notification__item--error']]: notification.type === 'error',
				[$style['notification__item--success']]: notification.type === 'success',
				[$style['notification__item--warning']]: notification.type === 'warning'
			}]"
		>
			<span :class="$style['notification__icon']">
				<svg v-if="notification.type === 'error'" viewBox="0 0 20 20" fill="currentColor">
					<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
				</svg>
				<svg v-else-if="notification.type === 'warning'" viewBox="0 0 20 20" fill="currentColor">
					<path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
				</svg>
				<svg v-else viewBox="0 0 20 20" fill="currentColor">
					<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
				</svg>
			</span>
			<span :class="$style['notification__message']">{{ notification?.message || '' }}</span>
		</div>
	</transition-group>
</template>

<script>
import { mapGetters } from '@/store/modules/Notification/helpers'
export default {
	name: 'Notification',
	computed: {
		...mapGetters({
			notifications: 'notifications'
		})
	}
}
</script>

<style module lang="scss">

.notification {
    display: flex;
    align-items: flex-end;
    gap: $gutter;

    // bottom-up stacking
    flex-direction: column-reverse;

    &__item {
        display: flex;
        align-items: center;
        gap: $gutter * 1.5;
        min-width: 280px;
        max-width: 360px;
        padding: $gutter * 1.5 $gutter * 2;
        border-radius: 6px;
        background: getColor(surface-elevated);
        color: getColor(text);
        box-shadow: 0 4px 12px rgb(0 0 0 / 0.15);
        transition: opacity 0.3s ease-out, transform 0.3s ease-out, box-shadow 0.3s ease-out;

        &--success {
            background-color: getColor(success-container);
            color: getColor(on-success-container);

            .notification__icon {
                color: getColor(success);
            }
        }

        &--error {
            background-color: getColor(error-container);
            color: getColor(on-error-container);

            .notification__icon {
                color: getColor(danger);
            }
        }

        &--warning {
            background-color: getColor(warning-container);
            color: getColor(on-warning-container);

            .notification__icon {
                color: getColor(warning-dark);
            }
        }
    }

    &__icon {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        display: flex;
        align-items: center;
        color: getColor(primary);

        svg {
            width: 100%;
            height: 100%;
        }
    }

    &__message {
        font-size: 14px;
        line-height: 1.4;
        font-weight: 500;
    }
}

</style>

<style lang="scss">
.rc-notification-enter-active,
.rc-notification-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.rc-notification-enter {
    opacity: 0;
    transform: translateY(20px);
}

.rc-notification-enter-to {
    opacity: 1;
    transform: translateY(0);
}

.rc-notification-leave-to {
    opacity: 0;
    transform: translateX(60px);
}

@media (prefers-reduced-motion: reduce) {
    .rc-notification-enter-active,
    .rc-notification-leave-active {
        transition: none;
    }
}
</style>
